/**
 * Values shared with CREExtension — keep identical to:
 * - `CREExtension/src/types/creConstants.ts` (`CRE_CHANNEL`)
 * - `CREExtension/src/types/mirrorProtocol.ts` (`MIRROR_STATE_MERGED_PAYLOAD_KEYS`)
 */
export const CRE_CHANNEL = "cre";

/** Host (e.g. addendum parent) → reporting iframe: open floating CRE mirror without sidebar Float button. */
export const CRE_OPEN_MIRROR_MESSAGE_TYPE = "OPEN_CRE_MIRROR";

/** R4V host → reporting iframe: trigger in-app save when user clicks Save/Submit in R4V. */
export const RADICAL_SAVE_REPORT_MESSAGE_TYPE = "RADICAL_SAVE_REPORT";

/**
 * R4V host → reporting iframe: peer review requested / cancelled on the study.
 *   { type: RADICAL_PEER_REVIEW_MESSAGE_TYPE, status: "requested" | "cancelled" }
 * requested → bold "Peer review has been requested" as first line of the Impression
 * (only if not already there); cancelled → that line is removed.
 * Reply (iframe → host):
 *   { type: RADICAL_PEER_REVIEW_RESULT_MESSAGE_TYPE, status, ok, changed, pending, reason? }
 */
export const RADICAL_PEER_REVIEW_MESSAGE_TYPE = "RADICAL_PEER_REVIEW";
export const RADICAL_PEER_REVIEW_RESULT_MESSAGE_TYPE = "RADICAL_PEER_REVIEW_RESULT";

/**
 * Reporting iframe → host (Radical/CRE parent): request parent page scroll while
 * the user drags near the visible top/bottom edge and the iframe itself cannot
 * scroll further. Host should listen and adjust its own scroll container:
 *   { type: MEDILIS_DRAG_SCROLL_MESSAGE_TYPE, direction: 1 | -1, step: number }
 */
export const MEDILIS_DRAG_SCROLL_MESSAGE_TYPE = "MEDILIS_DRAG_SCROLL";

/**
 * Host → reporting iframe: visible band of the iframe in the *iframe's own*
 * viewport coordinates (0 = top of iframe layout viewport). Needed when the
 * iframe element is taller than what the host column actually shows (clipped).
 *   { type: MEDILIS_VISIBLE_VIEWPORT_MESSAGE_TYPE, top: number, bottom: number }
 * Re-post on host scroll/resize so edge detection stays aligned with what the
 * user can see. Example: iframe is 1188px tall but only 500px visible →
 * `{ top: 0, bottom: 500 }` when the iframe top is flush with the clip.
 */
export const MEDILIS_VISIBLE_VIEWPORT_MESSAGE_TYPE = "MEDILIS_VISIBLE_VIEWPORT";

/** Greppable parity list when extending `mirror-state` past `labels`. */
export const MIRROR_STATE_MERGED_PAYLOAD_KEYS = Object.freeze([
  "patientName",
  "accessionNo",
  "patientGender",
  "mirrorFeedbackToken",
  "mirrorFeedbackLevel",
  "mirrorFeedbackMessage",
  "processAiBusy",
  "macroCommandMode",
  "templates",
  "selectedTemplateId",
  "newPatientBusy",
  "pageAuth",
]);
